import React from 'react';
import PropTypes from 'prop-types';
import { FormControl, Select, MenuItem, Input } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
  minimalInput: {
    border: '0px solid #e0e0e0',
    borderRadius: '4px',
    padding: '2px 6px',
    fontSize: '12px',
    height: '24px',
    width: '100%',
    '&:focus': {
      outline: 'none',
      borderColor: '#3f51b5',
      boxShadow: '0 0 0 1px rgba(63, 81, 181, 0.2)',
    },
    '&::placeholder': {
      color: '#999',
      fontSize: '11px',
    }
  },
  minimalSelect: {
    fontSize: '12px',
    '& .MuiSelect-select': {
      padding: '2px 6px',
      paddingRight: '20px !important',
      minHeight: 'auto',
      fontSize: '12px',
    },
    '& .MuiOutlinedInput-notchedOutline': {
      border: '1px solid #e0e0e0',
    },
    '& .MuiSelect-icon': {
      width: '16px',
      height: '16px',
      top: 'calc(50% - 8px)',
      right: '4px',
    }
  },
  selectContainer: {
    minHeight: '24px',
    '& .MuiFormControl-root': {
      minHeight: '24px',
    }
  }
}));

const FilterInput = ({ 
  type, 
  value, 
  onChange, 
  onKeyPress, 
  onBlur, 
  placeholder, 
  options = [], 
  style = {},
  fullWidth = false
}) => {
  const classes = useStyles();
  
  const baseStyle = {
    minWidth: type === 'select' ? '70px' : '60px',
    maxWidth: fullWidth ? 'none' : '120px',
    ...style
  };

  const handleChange = (event) => {
    onChange(event.target.value);
  };

  const handleKeyPress = (event) => {
    if (onKeyPress) {
      onKeyPress(event);
    }
  };

  const handleBlur = () => {
    if (onBlur) {
      onBlur();
    }
  };

  if (type === 'select') {
    return (
      <div style={baseStyle} className={classes.selectContainer}>
        <FormControl 
          variant="outlined" 
          size="small" 
          fullWidth
        >
          <Select
            value={value}
            onChange={handleChange}
            displayEmpty
            className={classes.minimalSelect}
          >
            {options.map((option) => (
              <MenuItem key={option.value} value={option.value} style={{ fontSize: '12px', minHeight: '24px', padding: '2px 8px' }}>
                {option.label}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </div>
    );
  }

  return (
    <div style={baseStyle}>
      <Input
        className={classes.minimalInput}
        placeholder={placeholder}
        type={type}
        value={value}
        onChange={(e) => handleChange(e)}
        onKeyPress={handleKeyPress}
        onBlur={handleBlur}
      />
    </div>
  );
};

FilterInput.propTypes = {
  type: PropTypes.oneOf(['text', 'number', 'select']).isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onChange: PropTypes.func.isRequired,
  onKeyPress: PropTypes.func,
  onBlur: PropTypes.func,
  placeholder: PropTypes.string,
  options: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
  })),
  style: PropTypes.shape({}),
  fullWidth: PropTypes.bool,
};

FilterInput.defaultProps = {
  value: '',
  onKeyPress: null,
  onBlur: null,
  placeholder: '',
  options: [],
  style: {},
  fullWidth: false,
};

export default FilterInput; 